module.exports = __webpack_public_path__ + "img/farm.4d4ea3c4.png";